export default {
  SET_CHAT(state, messages) {
    // Preserve the greeting message (first message) and append new messages
    state.chat = [
      state.chat[0], // Keep the greeting message
      ...messages, // Append new messages from Firestore
    ];
  },
  SET_THREAD_ID(state, threadId) {
    state.threadId = threadId;
    localStorage.setItem("threadId", threadId);
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_HISTORY_LOADING(state, loading) {
    state.historyLoading = loading;
  },
  SET_UNSUBSCRIBE(state, unsubscribe) {
    state.unsubscribe = unsubscribe;
  },
  CLEAR_UNSUBSCRIBE(state) {
    if (state.unsubscribe) {
      state.unsubscribe();
      state.unsubscribe = null;
    }
  },
  CLEAR_CHAT(state) {
    // Reset chat to just the greeting message
    state.chat = [
      {
        continuation: false,
        message: "Hello! What would you like to learn today?",
        senderID: "AI",
        timestamp: new Date().toISOString(), // Set timestamp to ISO format
      },
    ];
  },
  SET_CHAT_HISTORY(state, chatHistory) {
    state.chatHistory = chatHistory;
  },
};
